const Trinket = function (quality) {
  return {
    slot: 'off_hand',
    type: 'trinket',
    quality: quality,
    willpower: Math.round(3 + quality * 5),
    magicalGravity: quality * 2,
  };
};
module.exports = Trinket;
